import React from 'react';
import LiveChat from 'components/revelo-ui/content/livechat';

export default function LivechatTastic({ data }) {
  return <LiveChat {...data} />;
}
